import React, { useReducer } from 'react';
import { DialogComponent, Inputs, Spinner } from '../../../../../Components';
import ActivityTypesAutocomplete from './ActivityTypesAutocomplete';
import { envActivityCategory } from '../../../../../config';
import { DocumentsUploader } from '../../../../../SharedComponents/DocumentsUploader/DocumentsUploader';
import { showError } from '../../../../../Helper';

const activityReducer = (state, action) => {
  switch (action.type) {
    case 'SET_DESCRIPTION':
      return { ...state, description: action.payload };
    case 'SET_FILES':
      return { ...state, files: action.payload };
    case 'SET_ACTIVITY_TYPE':
      return {
        ...state,
        activityType: action.payload,
        activityTypeId: action.payload?.activityTypeId,
      };
    case 'RESET':
      return {
        activityTypeId: 0,
        activityType: null,
        description: '',
        files: [],
      };
    default:
      return state;
  }
};
const AddActivityDialog = ({
  generalClientTrackingId,
  vendorClientTrackingId,
  contactId,
  open,
  onClose,
  onSave,
}) => {
  const initialActivityState = React.useMemo(
    () => ({
      activityTypeId: 0,
      activityType: null,
      description: '',
      files: [],
      contactId,
      generalClientTrackingId,
      vendorClientTrackingId,
    }),
    [contactId, generalClientTrackingId, vendorClientTrackingId]
  );
  const [isLoading, setIsLoading] = React.useState(false);
  const [isSubmitted, setIsSubmitted] = React.useState(false);
  const [activityState, activityDispatch] = useReducer(
    activityReducer,
    initialActivityState
  );
  const onSaveHandler = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);
    if (!activityState.activityType) {
      showError('Please select activity type');
      return;
    }
    try {
      setIsLoading(true);

      await onSave(activityState);
      activityDispatch({
        type: 'RESET',
      });
      setIsSubmitted(false);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const onCloseHandler = () => {
    onClose();
    activityDispatch({
      type: 'RESET',
    });
    setIsSubmitted(false);
  };
  return (
    <DialogComponent
      titleText={'Add Activity'}
      isOpen={open}
      onCloseClicked={onCloseHandler}
      onCancelClicked={onCloseHandler}
      onSaveClicked={onSaveHandler}
      dialogContent={
        <div className='d-flex-column gap-1'>
          <Spinner isActive={isLoading} isAbsolute />
          <ActivityTypesAutocomplete
            onTypeChange={(value) =>
              activityDispatch({
                type: 'SET_ACTIVITY_TYPE',
                payload: value,
              })
            }
            selectedType={activityState.activityType}
            categoryId={
              vendorClientTrackingId
                ? envActivityCategory.loyaltyProgramClientTracking.lookupItemId
                : envActivityCategory.generalInquiryActions.lookupItemId
            }
            isWithError
            error={!activityState.activityType}
            isSubmitted={isSubmitted}
            helperText={'Please select activity type'}
          />
          <DocumentsUploader
            initUploaded={activityState.files}
            uploadedChanged={(value) =>
              activityDispatch({
                type: 'SET_FILES',
                payload: value,
              })
            }
            docTypes={{
              images: 0,
              docs: 2,
              links: 3,
            }}
          />
          <Inputs
            multiline
            onInputChanged={(e) =>
              activityDispatch({
                type: 'SET_DESCRIPTION',
                payload: e.target.value,
              })
            }
            value={activityState.description}
            labelValue={'Description'}
            inputPlaceholder={'Description'}
            rows={4}
          />
        </div>
      }
    />
  );
};
export default AddActivityDialog;
